import React from 'react'

function CustColor() {
  return (
    <>
    <h2>Custom Color</h2>
    <p className='p-doc'>text color</p>
    <code>cust-clr-[color code]</code>
    <br/>
    <br/>
    <p className='p-doc'>Background color</p>
    <code>cust-bg-[color code]</code>
    </>
  )
}

export default CustColor